import React, { useEffect, useState } from 'react';
import DashboardContent from './dashboardcontent/dashboardcontent';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { ClientDashboardService } from '../../../services/client-services/clientDashboardService';
import { decodeJWT } from '../../../services/candidateService';
import '../client-dashboard/dashboardcontent/dashboardcontent.css';

const formatDateForAPI = (date) => {
  if (!(date instanceof Date)) {
    console.error("Invalid date format received:", date);
    return null;
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0'); return `${year}-${month}-${day}`;
};


export const ClientDashboard = () => {
  const decoded = decodeJWT(window.localStorage.getItem('authToken'));
  const [dashboardData, setDashboardData] = useState({});
  const [shortlistAnalytics, setShortlistAnalytics] = useState({});
  const [selectedDate, setSelectedDate] = useState(null);
  const [isDateSelected, setIsDateSelected] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    ClientDashboardService.fetchDashboardData(decoded.clientId).then(response => {
      if (response.status === 200) {
        setDashboardData(response.data);
        const lastUpdatedMilliseconds = response.data.shortlistsResp?.shortlists[0]?.lastUpdated || Date.now();

        const lastUpdatedDate = new Date(lastUpdatedMilliseconds);
        if (!isDateSelected) {
          setSelectedDate(null);
        }
        fetchShortlistAnalytics(lastUpdatedDate).finally(() => setLoading(false));
      } else {
        setLoading(false);
      }
    })
      .catch(() => setLoading(false));
  }, [decoded.clientId, isDateSelected]);

  const fetchShortlistAnalytics = (date) => {
    if (!(date instanceof Date)) {
      console.error("fetchShortlistAnalytics received an invalid date:", date);
      return Promise.resolve();
    }

    const formattedDate = formatDateForAPI(date);

    ClientDashboardService.fetchShortlistAnalytics(decoded.clientId, formattedDate)
      .then(response => {
        if (response.status === 200) {
          setShortlistAnalytics(response.data);
        }
      })
      .catch(error => {
        console.error('Error fetching shortlist analytics:', error.response?.data || error.message);
        setShortlistAnalytics({});
      });
  };

  const handleDateChange = (date) => {
    if (!(date instanceof Date)) {
      console.error("handleDateChange received an invalid date:", date);
      return;
    }

    setSelectedDate(date);
    setIsDateSelected(true);
    fetchShortlistAnalytics(date);
  };

  return (
    <>
      <div className="fluid-container">
        <DashboardContent
          dashboardData={dashboardData}
          shortlistAnalytics={shortlistAnalytics}
          selectedDate={selectedDate}
          onDateChange={handleDateChange}
          isDateSelected={isDateSelected}
        />
      </div>

      {loading && (
        <div className="dashboard-loader-container">
          <div className="dashboard-loader"></div>
        </div>
      )}
    </>
  );

};